// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__Kcp4U","content":"RecentSearches_content__3lzY6"};